/* eslint-disable no-useless-escape */
export const regexAlphabetNumberUnderDash = /^[A-Za-z0-9_-]*$/

export function validEmail(e = '') {
  const filter = new RegExp(
    /^\s*[\w\-\+_]+(\.[\w\-\+_]+)*\@[\w\-\+_]+\.[\w\-\+_]+(\.[\w\-\+_]+)*\s*$/,
  )
  return String(e).search(filter) != -1
}
